<template>
  <div class="admin-root admin-login-page" :style="{ backgroundImage: `url(${bg})` }">
    <div class="middle-box">
      <img class="login-logo" :src="logo" alt="logo" />
      <form class="login-form" @submit.prevent="onSubmit">
        <h3>欢迎登录天星堪舆后台</h3>
        <div class="form-group">
          <input type="text" class="form-control" v-model="form.login_name" placeholder="用户名" required />
        </div>
        <div class="form-group">
          <input type="password" class="form-control" v-model="form.password" placeholder="密码" required />
        </div>
        <button type="submit" class="btn-login" :disabled="loading">{{ loading ? '登录中...' : '登录' }}</button>
      </form>
      <p class="login-copyright"><small>Copyright 天星堪舆 &copy; 2020-2022</small></p>
    </div>
  </div>
</template>

<script>
import { authApi } from '../api/admin'

export default {
  name: 'AdminLogin',
  data () {
    return {
      form: { login_name: '', password: '' },
      loading: false,
      // 原版登录页随机取 bg1/bg2 背景图
      bg: `/admin/img/bg${Math.floor(Math.random() * 2) + 1}.jpg`,
      logo: '/admin/img/logo.png'
    }
  },
  methods: {
    async onSubmit () {
      if (!this.form.login_name || !this.form.password) return
      this.loading = true
      try {
        await authApi.login(this.form.login_name, this.form.password)
        this.$router.replace(this.$route.query.redirect || '/admin/dashboard')
      } catch (e) {
        this.$message.error(e.uiMessage || e.message || '登录失败')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss">
@import url('/admin/font-awesome/css/font-awesome.min.css');
@import '../styles/admin-theme.scss';
</style>
